<template>
  <div class="video">
    <iframe
      class="video__iframe"
      :src="`https://player.vimeo.com/video/${resourceId}`"
      allow="autoplay; fullscreen"
      allowfullscreen
      :title="$t('trainingCourse.material.video.title')"
    ></iframe>
    <link-material
      v-if="pdf"
      :linkUrl="pdf"
      :label="$t('trainingCourse.material.video.linkLabel')"
    />
    <resources-material :links="links" />
  </div>
</template>

<script>
import LinkMaterial from './Link'
import ResourcesMaterial from './Resources'

export default {
  components: {
    LinkMaterial,
    ResourcesMaterial,
  },
  props: {
    resourceId: String,
    pdf: String,
    links: Array,
  },
}
</script>

<style lang="scss" scoped>
.video {
  color: black;

  &__iframe {
    width: 100%;
    height: 400px;
  }
}
</style>
